import { SquareLoader } from '@components';
import PropTypes from 'prop-types';

const LoadingPage = ({ message }) => {
  return (
    <div className="flex items-center flex-col justify-center h-screen bg-gradient-to-r dark:from-[#363639] dark:to-[#121212]">
      <SquareLoader />

      <div className="mt-3 text-center">
        <h1 className="mb-1 text-3xl font-bold text-foreground-700">Please wait loading...</h1>
        <p className="text-lg dark:text-white">{message}</p>
      </div>
    </div>
  );
}

LoadingPage.propTypes = {
  message: PropTypes.string.isRequired
};

export default LoadingPage;